import * as React from "react";
import { IconAngleDoubleLeft, IconAngleDoubleRight, IconAngleLeft, IconAngleRight } from "themes/icons";
import { PaginationContainer } from "./style/pagination-style";
export interface IPaginationProps {
  currentPage: number;
  totalPageCount: number;
  totalItemCount: number;
  onChange: (value: number) => void;
}

export const Pagination = (props: IPaginationProps) => {
  const { currentPage, totalPageCount, totalItemCount, onChange } = props;
  const start = currentPage - totalItemCount >= 1 ? (currentPage - totalItemCount) : 1;
  const end = currentPage + totalItemCount <= totalPageCount ? (currentPage + totalItemCount) : totalPageCount;
  const handleRenderPagination = () => {
    let pagination = [];
    if (currentPage > 2) {
      pagination.push(<li>
        <button aria-label={`Click change page 1`} onClick={() => {
          onChange(1);
        }} >
          <IconAngleDoubleLeft width={10} />
        </button>
      </li>)
    }
    if (start > 1) {
      pagination.push(<li className="disabled">
        <span>…</span>
      </li>)
    }
    if (currentPage > 1) {
      pagination.push(<li>
        <button aria-label={`Click change page ${currentPage - 1}`} onClick={() => {
          onChange(currentPage - 1);
        }} >
          <IconAngleLeft width={10} />
        </button>
      </li>)
    }
    let list = [];
    for (var index = start; index <= end; index++) {
      list.push(index);
    }
    list.forEach((m) => {
      if (currentPage === m) {
        pagination.push(<li className="active">
          <span>{m}</span>
        </li>)
      } else {
        pagination.push(<li key={m}>
          <button aria-label={`Click change page ${m}`} onClick={() => {
            onChange(m)
          }}>{m}</button>
        </li>)
      }
    })
    if (end < totalPageCount) {
      pagination.push(<li className="disabled">
        <span>…</span>
      </li>)
    }
    if (currentPage < totalPageCount) {
      pagination.push(
        <li>
          <button
            aria-label={`Click change page ${currentPage + 1}`}
            onClick={() => {
              onChange(currentPage + 1);
            }}
          >
            <IconAngleRight width={10} />
          </button>
        </li>
      )
    }
    if (currentPage < totalPageCount - 2) {
      pagination.push(
        <li>
          <button
           aria-label={`Click change page ${totalPageCount}`}
            onClick={() => {
              onChange(totalPageCount);
            }}
          >
            <IconAngleDoubleRight width={10} />
          </button>
        </li>
      )
    }
    return pagination;
  }
  return (
    <PaginationContainer>
      <ul className="pagination">
        {handleRenderPagination()}
      </ul>
    </PaginationContainer>
  );
};
export default Pagination;
